import { length, map } from 'ramda';
import { ChartData } from '../entities';

export const getDynamicPriceStateAtPeriod = (data: ChartData[]) => {
  const dataToPairs = map((chartData: ChartData) => [chartData.time, chartData.open], data);
  const openPriceAtPeriod = dataToPairs[0][1];
  const closePriceAtPeriod = dataToPairs[dataToPairs.length - 1][1];
  return length(dataToPairs) > 0 && openPriceAtPeriod < closePriceAtPeriod;
};
